import { createMuiTheme } from '@material-ui/core/styles';
var commonTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3C1587',
            light: '#EEEBFF',
        },
        secondary: {
            dark: '#277A6F',
            main: '#2F9487',
            light: '#40AD9F',
        },
        error: {
            main: '#D12D2C;',
        },
        background: {
            default: '#F2F2F2',
        },
        text: {
            primary: '#3C3C3C',
            secondary: '#A3A3A3',
        },
        grey: {
            A200: '#A3A3A3',
        },
    },
    typography: {
        caption: {
            color: '#A3A3A3',
        },
    },
});
export default commonTheme;
//# sourceMappingURL=Theme.js.map